import { useFormikContext } from "formik";

export const useIsFormChanged = () => {
  const { dirty } = useFormikContext();

  return dirty;
};
